import React, { useState, useEffect } from "react";
import { Dialog } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/solid";
import MuxPlayer from "@mux/mux-player-react";

interface TutorialDialogProps {
  isOpen: boolean;
  onClose: () => void;
  videoUrl: string;
  title?: string;
}

export default function TutorialDialog({
  isOpen,
  onClose,
  videoUrl,
  title = "How to Position Items",
}: TutorialDialogProps) {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const handleClose = () => {
    if (dontShowAgain) {
      // Save preference in localStorage
      localStorage.setItem("hideItemPositioningTutorial", "true");
    }
    onClose();
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      className="relative z-[70]" // Higher z-index than the main dialog
    >
      <div className="fixed inset-0 bg-black/60" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="w-full max-w-lg bg-white dark:bg-gray-900 rounded-xl shadow-xl overflow-hidden">
          {/* Header */}
          <div className="flex justify-between items-center px-4 py-3 border-b border-gray-200 dark:border-gray-800">
            <Dialog.Title className="text-lg font-semibold text-gray-900 dark:text-white">
              {title}
            </Dialog.Title>
            <button
              onClick={handleClose}
              className="text-gray-400 hover:text-gray-500 dark:text-gray-300 dark:hover:text-gray-200 rounded-full p-1 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
            >
              <XMarkIcon className="h-5 w-5" />
            </button>
          </div>

          {/* Video */}
          <div className="p-4 bg-gray-50 dark:bg-gray-800">
            <div className="w-full rounded-lg overflow-hidden">
              <MuxPlayer
                className="w-full h-full"
                playbackId="7jTGn00LtfMJ8oPdOcrF2ArdBgT4FCacwzMK01Nan8rfY"
                autoPlay
                loop
                muted
                playsInline
              />
            </div>

            <div className="mt-4 text-sm text-gray-700 dark:text-gray-300 mx-auto text-center">
              <p>
                Drag, resize, and rotate the item to cover the original product.
              </p>
            </div>
          </div>

          {/* Footer */}
          <div className="p-4 border-t border-gray-200 dark:border-gray-800 flex flex-wrap justify-between items-center gap-4">
            <label className="flex items-center">
              <input
                type="checkbox"
                checked={dontShowAgain}
                onChange={(e) => setDontShowAgain(e.target.checked)}
                className="rounded border-gray-300 text-purple-600 focus:ring-purple-500 h-4 w-4 dark:border-gray-600 dark:bg-gray-800"
              />
              <span className="ml-2 text-sm text-gray-600 dark:text-gray-400">
                Don't show again
              </span>
            </label>

            <button
              onClick={handleClose}
              className="px-6 py-2 bg-purple-600 hover:bg-purple-700 text-white font-medium rounded-lg transition-colors shadow-sm"
            >
              Got it
            </button>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
}
